import { c as _c } from "react/compiler-runtime";
import React, { ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './ButtonStandard.module.css';
export enum ButtonStandardType {
  Primary = 'primary',
  Secondary = 'secondary',
  Danger = 'danger',
  TextPrimary = 'textPrimary',
  TextSecondary = 'textSecondary',
  TextDanger = 'textDanger',
}
export enum ButtonStandardHoverEffectType {
  None = 'none',
  HalfTransparent = 'halfTransparent',
}
export type ButtonStandardProps = Omit<ComponentProps<'button'>, 'type'> & {
  readonly type?: ButtonStandardType;
  readonly hoverEffectType?: ButtonStandardHoverEffectType;
};
export const ButtonStandard = React.memo<ButtonStandardProps>(props => {
  const $ = _c(12);
  let children;
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== props) {
    const {
      type: t4,
      hoverEffectType: t5,
      className,
      children: t6,
      ref,
      ...remainingProps
    } = prepareProps({
      props
    });
    children = t6;
    const type = t4 === undefined ? ButtonStandardType.Secondary : t4;
    const hoverEffectType = t5 === undefined ? ButtonStandardHoverEffectType.None : t5;
    t0 = ref;
    t1 = "button";
    t2 = remainingProps;
    t3 = classes(className, styles.button, buttonTypeToClassName[type], hoverEffectTypeToClassName[hoverEffectType]);
    $[0] = props;
    $[1] = children;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    children = $[1];
    t0 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children || $[7] !== t0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <button ref={t0} type={t1} {...t2} className={t3}>{children}</button>;
    $[6] = children;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
});
const buttonTypeToClassName: Record<ButtonStandardType, string | null> = {
  [ButtonStandardType.Primary]: styles.buttonPrimary,
  [ButtonStandardType.Secondary]: styles.buttonSecondary,
  [ButtonStandardType.Danger]: styles.buttonDanger,
  [ButtonStandardType.TextPrimary]: styles.buttonTextPrimary,
  [ButtonStandardType.TextSecondary]: styles.buttonTextSecondary,
  [ButtonStandardType.TextDanger]: styles.buttonTextDanger
};
const hoverEffectTypeToClassName: Record<ButtonStandardHoverEffectType, string | null> = {
  none: null,
  halfTransparent: styles.hoverEffectHalfTransparent
};